import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import { ProjectCardWidget } from "./ProjectCard.jsx";
import { SkeletonCarousel } from './SkeletonCarousel.jsx';

export function ProjectListWidget({configuration}) {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    getProjects();
  }, []);

  const headers = {
      "Accept-Language": window.location.pathname.split("/")[1],
  }

  const getProjects = async () => {
    setIsLoading(true);
    fetch(configuration.endpoint, {headers: headers})
      .then(response => response.json())
      .then(data => {
        setProjects(data.results);
        setIsLoading(false);
      }).catch(error => {
        console.log(error);
        setIsLoading(false);
      })
  };

  let title = configuration.translations.title;
  let out;
  if (projects.length > 0) {
    out = (
      <div>
          <div className="titulo">
            {title}
          </div>

            <Slider {...configuration.settings} infinite={projects.length > configuration.settings.slidesToShow}>
              {projects.map(project => 
                <ProjectCardWidget
                  key={project.pk} 
                  project={project}
                  configuration={configuration}
                  />
              )}
            </Slider>
      </div>
    );
  } else {
    out = "";
  }

  return (
    <>
      { isLoading ? <SkeletonCarousel /> : out }
    </>
  )
}
